module.exports = __webpack_public_path__ + "images/invoice_receipt/logo-paid-stamp.png";